// extracted by mini-css-extract-plugin
export default {"percentLoader":"PercentsSpinner_percentLoader__fQFJn","descriptions":"PercentsSpinner_descriptions__sqt2i","overlay":"PercentsSpinner_overlay__DrNS4"};